import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui";

export const Card = styled.div`
    width: 100%;
    max-width: 420px;
    padding: 40px 32px;
    border-radius: ${radii.base};
    background: ${colors.surface};
    box-shadow: ${shadows.panel};
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (max-width: 480px) {
        padding: 28px 20px;
    }
`;

export const Logo = styled.img`
    height: 30px;
    align-self: center;
`;

export const Subtitle = styled.div`
    text-align: center;
    font-size: 15px;
    color: ${colors.textSecondary};
`;
